import React, { useState } from 'react'
import { Form, Input, Message, Radio, RadioGroup } from 'rsuite'
import { isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'

export default function RadioForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  otherKey,
  disabled,
  selectedOther,
  value,
  otherValue,
}) {
  const [schema, setSchema] = useState(_schema)
  const [isSelectOther, setIsSelectOther] = useState(selectedOther)
  const [isDisabled, setIsDisabled] = useState(disabled || _schema?.disabled)

  return (
    <Form style={{ marginTop: 10, marginBottom: 10 }}>
      <div>
        {schema.description && <CustomIconMessageInfo content={schema.description} />}
        {errors[schema.name] && (
          <Message showIcon type="error" description={errors[schema.name].message} />
        )}
        <p>{requiredFiled(schema.validators, schema.label)}</p>
        <Controller
          key={schema.name}
          name={schema.name}
          control={control}
          defaultValue={value || schema.value}
          rules={isValidators(schema.validators)}
          render={(props) => {
            return (
              <RadioGroup
                value={props.value}
                disabled={isDisabled}
                onChange={(value) => {
                  // console.log('value=', value)
                  props.onChange(value)
                  const otherOption = schema.options
                    ?.filter((e) => e.value == value)
                    ?.shift()?.otherOption
                  // console.log('otherOption=', otherOption)
                  if (!otherOption) {
                    setValue(otherKey || schema.name + '_inputOther', '')
                    clearErrors(otherKey || schema.name + '_inputOther')
                  }
                  setIsSelectOther(otherOption)
                }}
              >
                {schema.options?.map((item, index) => (
                  <div key={schema.name + '_' + index}>
                    <Radio key={item.value} value={item.value} disabled={schema.disabled}>
                      {item.label}
                    </Radio>
                    {item.otherOption && (
                      <>
                        {errors[otherKey || schema.name + '_inputOther'] && (
                          <div style={{ paddingLeft: 30 }}>
                            <Message
                              showIcon
                              type="error"
                              description={'เนื่องจากเลือกอื่นๆ กรุณาระบุข้อมูลเพิ่มเติม'}
                            />
                          </div>
                        )}
                        <Input
                          name={otherKey || schema.name + '_inputOther'}
                          style={{ width: 'calc(100% - 35px)', marginLeft: 35 }}
                          placeholder="กรุณาระบุ"
                          defaultValue={
                            otherValue || schema[otherKey || schema.name + '_inputOther']
                          }
                          disabled={!isSelectOther || isDisabled}
                          inputRef={register({
                            required: isSelectOther
                              ? 'เนื่องจากเลือกอื่นๆ กรุณาระบุข้อมูลเพิ่มเติม'
                              : false,
                          })}
                        />
                      </>
                    )}
                  </div>
                ))}
              </RadioGroup>
            )
          }}
        />
      </div>
    </Form>
  )
}
